import React from "react";
import CrudPage from "../components/CrudPage";
import { FaStar } from "react-icons/fa";

const fields = [
  { key: "name", label: "Client Name", placeholder: "Amit Sharma" },
  { key: "role", label: "Role / Company", placeholder: "Founder, TechStartup" },
  { key: "city", label: "City", placeholder: "Noida" },
  { key: "emoji", label: "Avatar Emoji", placeholder: "👨" },
  { key: "rating", label: "Rating (1-5)", type: "number", min: 1, max: 5 },
  { key: "text", label: "Testimonial Text", type: "textarea" },
  { key: "order", label: "Display Order", type: "number", min: 0 },
];

const renderCard = (item) => (
  <div>
    <div className="flex items-center gap-2 mb-2">
      {Array.from({ length: item.rating || 5 }).map((_, i) => (
        <FaStar key={i} className="text-yellow-400 text-xs" />
      ))}
    </div>
    <p className="text-gray-400 text-xs leading-relaxed mb-3 line-clamp-3">"{item.text}"</p>
    <div className="flex items-center gap-2">
      <div className="w-8 h-8 gradient-bg rounded-full flex items-center justify-center text-sm">{item.emoji || "👤"}</div>
      <div>
        <p className="text-white text-xs font-semibold">{item.name}</p>
        <p className="text-gray-500 text-xs">{item.role} • {item.city}</p>
      </div>
    </div>
  </div>
);

export default function TestimonialsPage() {
  return <CrudPage title="Testimonials" endpoint="testimonials" fields={fields} renderCard={renderCard} />;
}
